import Vue from "vue";
import Home from "~/pages/index.vue";
import Login from "~/pages/login.vue";
import About from "~/pages/about.vue";
import TermsOfUse from "~/pages/terms-of-use.vue";
import ActiveEmail from "~/pages/active-email/_id.vue";
import CoursesSubCat from "~/pages/courses/_cat/_sub/_subId.vue";

import CourseDetails from "~/pages/courses/_en_category/_en_subcategory/_id/_course_title_encourses.vue";
import Basket from "~/pages/basket.vue";
import Tuition from "~/pages/tuition.vue";
import InstructorRequest from "~/pages/instructor-request.vue";
import Creator from "~/pages/user/_id.vue";
import ResultPayment from "~/pages/result-payment/_id.vue";
// user page
import MyCourses from "~/pages/my-courses.vue";
import Learning from "~/pages/learning.vue";
import Content from "~/pages/content.vue";
import ListContent from "~/pages/courses/_en_category/_en_subcategory/_id/_course_title_encourses/list-content/index.vue";
import Discuss from "~/pages/courses/_en_category/_en_subcategory/_id/_course_title_encourses/discuss/index.vue";
import CourseDescription from "~/pages/courses/_en_category/_en_subcategory/_id/_course_title_encourses/course-description/index.vue";
import Comments from "~/pages/courses/_en_category/_en_subcategory/_id/_course_title_encourses/comment/index.vue";
// blog page
import Blog from "~/pages/blog/index.vue";
import BlogDetails from "~/pages/blog/_id.vue";
// Dashboard
import Dashboard from "~/pages/dashboard/dashboard.vue";
// Dashbord Profile
// D = dashbord
import Dprofile from "~/pages/dashboard/profile.vue";
import Dwish from "~/pages/dashboard/wish.vue";
import DuserEdit from "~/pages/dashboard/user/_id.vue";
import DmyTickets from "~/pages/dashboard/my-tickets.vue";
import Dcategory from "~/pages/dashboard/category.vue";
import Dsubcategory from "~/pages/dashboard/subcategory.vue";
import Dtag from "~/pages/dashboard/tag.vue";
import Dusers from "~/pages/dashboard/users.vue";
import Dallcourses from "~/pages/dashboard/allcourses.vue";
import DِinstructorsManagement from "~/pages/dashboard/instructors-management.vue";
import Dcomments from "~/pages/dashboard/comments.vue";
import Ddiscusses from "~/pages/dashboard/discusses.vue";
import Dtickets from "~/pages/dashboard/tickets.vue";
import Doffers from "~/pages/dashboard/offers.vue";
import Dabuse from "~/pages/dashboard/abuse.vue";
import DblogAdd from "~/pages/dashboard/blog/add.vue";
import DblogList from "~/pages/dashboard/blog/index.vue";
import DblogListManage from "~/pages/dashboard/blog/manage.vue";
import DblogEdit from "~/pages/dashboard/blog/edit.vue";
import Dmonitoring from "~/pages/dashboard/monitoring.vue";
import Dpayment from "~/pages/dashboard/payment.vue";
import DmyPayment from "~/pages/dashboard/my-payment.vue";
import Drules from "~/pages/dashboard/rules.vue";
import DcourseForm from "~/pages/dashboard/new-course.vue";
import Dinstructors from "~/pages/dashboard/instructors.vue";
import Dsections from "~/pages/dashboard/sections.vue";
import Dgoals from "~/pages/dashboard/goals.vue";
import Dmessages from "~/pages/dashboard/messages.vue";
import Doffercode from "~/pages/dashboard/offercode.vue";
import Dmycourses from "~/pages/dashboard/mycourses.vue";
import Dpassword from "~/pages/dashboard/password.vue";
import Dsettlement from "~/pages/dashboard/settlement.vue";
import Dcalls from "~/pages/dashboard/calls.vue";

import page404 from "~/pages/404page.vue";

// /dashboar/profile
import VueRouter from "vue-router";

import i18n from "~/i18n";
import { store } from "~/store/index.js";
const filterRoute = [
  "/login",
  "/about",
  "/terms-of-use",
  "/basket",
  "/teaching",
  "/instructor-request",
  "/my-courses",
  "/learning",
  "/content",
  "/blog"
];
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Home,
    meta: {
      title: i18n.t("nameApp"),
      auth: false
    }
  },
  {
    path: "/active-email/:activeId",
    component: ActiveEmail,
    meta: {
      title: i18n.t("nameApp"),
      auth: false
    }
  },
  {
    path: "/result-payment/:id",
    component: ResultPayment,
    meta: {
      title: i18n.t("nameApp"),
      auth: false
    }
  },
  {
    path: "/courses/:en_category/:en_subcategory/:id/:course_title_encourses",
    component: CourseDetails,
    name: "courses-detalis",
    meta: {
      title: i18n.t("meta.title.courseDetails"),
      auth: false
    }
  },
  {
    path: "/user/:id",
    component: Creator,
    meta: {
      title: i18n.t("meta.title.creator"),
      auth: false
    }
  },
  {
    path: "/:id",
    beforeEnter: (to, from, next) => {
     window.location.href = `https://www.madya.ir/instructor/${to.params.id}/courses`
    },
    meta: {
      title: i18n.t("meta.title.creator"),
      auth: false
    }
  },
  {
    path: "/courses/:cat/:sub/:subId",
    component: CoursesSubCat,
    meta: {
      title: i18n.t("meta.title.category"),
      auth: false
    }
  },
  {
    path: "/v1/login",
    component: Login,
    meta: {
      title: i18n.t("meta.title.login"),
      auth: false
    }
  },
  {
    path: "/v1/about",
    component: About,
    meta: {
      title: i18n.t("meta.title.about"),
      auth: false
    }
  },
  {
    path: "/v1/terms-of-use",
    component: TermsOfUse,
    meta: {
      title: i18n.t("meta.title.termsOfUse"),
      auth: false
    }
  },
  {
    path: "/v1/basket",
    component: Basket,
    meta: {
      title: i18n.t("meta.title.basket"),
      auth: false
    }
  },
  {
    path: "/v1/teaching",
    component: Tuition,
    meta: {
      title: i18n.t("meta.title.tuition"),
      auth: false
    }
  },
  {
    path: "/v1/instructor-request",
    component: InstructorRequest,
    name: "instructor-request",
    meta: {
      title: i18n.t("meta.title.instructorRequest"),
      auth: true
    }
  },
  {
    path: "/v1/my-courses",
    component: MyCourses,
    redirect: "/v1/learning",

    meta: {
      title: i18n.t("meta.title.myCourses"),
      auth: false
    },
    children: [
      {
        path: "/v1/learning",
        component: Learning,
        meta: {
          title: i18n.t("menu.learning"),
          auth: false
        }
      }
    ]
  },
  {
    path: "/v1/content",
    component: Content,
    meta: {
      title: i18n.t("meta.title.content"),
      auth: false
    },
    children: [
      {
        path:
          "/courses/:en_category/:en_subcategory/:id/:course_title_encourses/list-content",
        component: ListContent,
        meta: {
          title: i18n.t("meta.title.listContent"),
          auth: false
        }
      },
      {
        path:
          "/courses/:en_category/:en_subcategory/:id/:course_title_encourses/course-description",
        component: CourseDescription,
        meta: {
          title: i18n.t("meta.title.courseDescription"),
          auth: false
        }
      },
      {
        path:
          "/courses/:en_category/:en_subcategory/:id/:course_title_encourses/discuss",
        component: Discuss,
        meta: {
          title: i18n.t("meta.title.discuss"),
          auth: false
        }
      },
      {
        path:
          "/courses/:en_category/:en_subcategory/:id/:course_title_encourses/comment",
        component: Comments,
        meta: {
          title: i18n.t("meta.title.comments"),
          auth: false
        }
      }
    ]
  },
  {
    path: "/v1/blog",
    component: Blog,
    meta: {
      title: i18n.t("menu.mags"),
      auth: false
    }
  },
  {
    path: "/blog-details/:id",
    component: BlogDetails,
    meta: {
      title: i18n.t("menu.mags"),
      auth: false
    }
  },

  {
    path: "/dashboard",
    component: Dashboard,
    redirect1: "/dashboard/profile",
    meta: {
      title: i18n.t("dashboardMenu.dashboard"),
      auth: true
    },
    children: [
      {
        path: "/dashboard/profile",
        component: Dprofile,
        meta: {
          title: i18n.t("dashboardMenu.profile"),
          auth: true
        }
      },
      {
        path: "/dashboard/user/:id",
        component: DuserEdit,
        meta: {
          title: i18n.t("dashboardMenu.user"),
          auth: true
        }
      },
      {
        path: "/dashboard/wish",
        component: Dwish,
        meta: {
          title: "لیست علاقه مندی ها",
          auth: true
        }
      },
      {
        path: "/dashboard/my-tickets",
        component: DmyTickets,
        meta: {
          title: i18n.t("dashboardMenu.myTickets"),
          auth: true
        }
      },
      {
        path: "/dashboard/category",
        component: Dcategory,
        meta: {
          title: i18n.t("dashboardMenu.category"),
          auth: true
        }
      },

      {
        path: "/dashboard/subcategory",
        component: Dsubcategory,
        meta: {
          title: i18n.t("dashboardMenu.subcategory"),
          auth: true
        }
      },
      {
        path: "/dashboard/tag",
        component: Dtag,
        meta: {
          title: i18n.t("dashboardMenu.tag"),
          auth: true
        }
      },
      {
        path: "/dashboard/users",
        component: Dusers,
        meta: {
          title: i18n.t("dashboardMenu.users"),
          auth: true
        }
      },
      {
        path: "/dashboard/allcourses",
        component: Dallcourses,
        meta: {
          title: i18n.t("dashboardMenu.allcourses"),
          auth: true
        }
      },
      {
        path: "/dashboard/instructors-management",
        component: DِinstructorsManagement,
        meta: {
          title: 'مدیریت مدرسین',
          auth: true
        }
      },
      {
        path: "/dashboard/comments",
        component: Dcomments,
        meta: {
          title: i18n.t("dashboardMenu.comments"),
          auth: true
        }
      },
      {
        path: "/dashboard/discusses",
        component: Ddiscusses,
        meta: {
          title: i18n.t("dashboardMenu.discusses"),
          auth: true
        }
      },
      {
        path: "/dashboard/tickets",
        component: Dtickets,
        meta: {
          title: i18n.t("dashboardMenu.tickets"),
          auth: true
        }
      },
      {
        path: "/dashboard/offers",
        component: Doffers,
        meta: {
          title: i18n.t("dashboardMenu.offers"),
          auth: true
        }
      },
      {
        path: "/dashboard/abuse",
        component: Dabuse,
        meta: {
          title: i18n.t("dashboardMenu.abuse"),
          auth: true
        }
      },
      {
        path: "/dashboard/blog/add",
        component: DblogAdd,
        meta: {
          title: i18n.t("dashboardMenu.blog"),
          auth: true,
          isSub: true,

        }
      },
      {
        path: "/dashboard/blog/manage",
        component: DblogListManage,
        meta: {
          title: i18n.t("dashboardMenu.blogList"),
          auth: true,
          isSub: true,
        }
      },
      {
        path: "/dashboard/blog/list",
        component: DblogList,
        meta: {
          title: i18n.t("dashboardMenu.blogList"),
          auth: true,
          isSub: true,
        }
      },
      {
        path: "/dashboard/blog/edit/:id",
        component: DblogEdit,
        meta: {
          title: i18n.t("dashboardMenu.blogEdit"),
          auth: true
        }
      },
      {
        path: "/dashboard/monitoring",
        component: Dmonitoring,
        meta: {
          title: i18n.t("dashboardMenu.monitoring"),
          auth: true
        }
      },
      {
        path: "/dashboard/my-payment",
        component: DmyPayment,
        meta: {
          title: i18n.t("dashboardMenu.payment"),
          auth: true
        }
      },
      {
        path: "/dashboard/payment",
        component: Dpayment,
        meta: {
          title: i18n.t("dashboardMenu.payment"),
          auth: true
        }
      },
      {
        path: "/dashboard/rules",
        component: Drules,
        meta: {
          title: i18n.t("dashboardMenu.rules"),
          auth: true
        }
      },
      {
        path: "/dashboard/new-course",
        name: "courseForm",
        component: DcourseForm,
        meta: {
          title: i18n.t("dashboardMenu.courseForm"),
          auth: true,
          isSub: true
        }
      },
      {
        path: "/dashboard/instructors",
        component: Dinstructors,
        meta: {
          title: i18n.t("dashboardMenu.instructors"),
          isSub: true,
          auth: true
        }
      },
      {
        path: "/dashboard/sections",
        component: Dsections,
        meta: {
          title: i18n.t("dashboardMenu.sections"),
          isSub: true,
          auth: true,
          hasId: true
        }
      },
      {
        path: "/dashboard/goals",
        component: Dgoals,
        meta: {
          title: i18n.t("dashboardMenu.goals"),
          isSub: true,
          auth: true,
          hasId: true
        }
      },
      {
        path: "/dashboard/messages",
        component: Dmessages,
        meta: {
          title: i18n.t("dashboardMenu.messages"),
          isSub: true,
          auth: true,
          hasId: true
        }
      },
      {
        path: "/dashboard/offercode",
        component: Doffercode,
        meta: {
          title: i18n.t("dashboardMenu.offercode"),
          auth: true
        }
      },
      {
        path: "/dashboard/mycourses",
        component: Dmycourses,
        meta: {
          title: i18n.t("dashboardMenu.mycourses"),
          auth: true
        }
      },
      {
        path: "/dashboard/password",
        component: Dpassword,
        meta: {
          title: i18n.t("dashboardMenu.password"),
          auth: true
        }
      },
      {
        path: "/dashboard/settlement",
        component: Dsettlement,
        meta: {
          title: "وضعیت مالی",
          auth: true
        }
      },
      {
        path: "/dashboard/calls",
        component: Dcalls,
        meta: {
          title: "لیست تماس با ما",
          auth: true
        }
      }
    ]
  },
  {
    path: "*",
    component: page404,
    meta: {
      title: "خطای 404"
    }
  }
];
const router = new VueRouter({
  routes,
  base: "/",
  mode: "history"
});
// Check route access

var routerCheck = {
  login(to, from, next, token, id) {
    if (to.meta.auth && !token) {
      next("/v1/login?callBackUrl=" + to.fullPath);
    } else if (to.name === "Login" && token) {
      next("/");
    } else {
      next();
    }
  }
};
router.beforeEach((to, from, next) => {
  // document.getElementsByTagName("meta")["description"].content = i18n.t("des");

  // document.title = to.meta.title;
  var token = !!localStorage.getItem("user");
  var id = !!sessionStorage.getItem("course_id");
  let valid = !!(to.meta.isSub && id);
  if (valid) {
    routerCheck.login(to, from, next, token, id);
  } else {
    if (!id) {
      routerCheck.login(to, from, next, token, id);
      return;
    }
    let result = window.confirm("آیا میخواهید از دوره ساز خارج شوید");
    if (result) {
      sessionStorage.removeItem("course_id");
      sessionStorage.removeItem("isMultiInst");
      routerCheck.login(to, from, next, token, id);
    } else {
      next(`${from.path}`);
      return;
    }
  }
  routerCheck.login(to, from, next, token, id);
});
export default router;



// WEBPACK FOOTER //
// ./src/routes.js